
import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import CheckoutForm from "./CheckoutForm";

const stripePromise = loadStripe("pk_live_51Qnm0jDlkio8pUGzsgPanjgIMU5dQSlq8K0AYJc5Bh9tGXxPxpEb2n1C1yl6TSXbuRuo8eB1SpwSrJrZADOBn0Ia00VoQ4xp7U");

interface BookingModalContentProps {
  clientSecret: string;
  onSuccess: () => void;
}

const BookingModalContent = ({ clientSecret, onSuccess }: BookingModalContentProps) => {
  const stripeOptions = {
    clientSecret,
    appearance: {
      theme: 'stripe' as const,
    },
  };

  return (
    <Elements stripe={stripePromise} options={stripeOptions}>
      <CheckoutForm onSuccess={onSuccess} />
    </Elements>
  );
};

export default BookingModalContent;
